import Image from '/components/Image';
import PropTypes from 'prop-types';
import Typography from '/components/Typography';

import { getProduct } from '/services/products';
import { useEffect } from 'react';

const Box = ({ builderConfig, packConfig, updatePackConfig }) => {
	useEffect(() => {
		const fetchBox = async () => {
			const boxProduct = await getProduct(builderConfig.box.handle);

			if (boxProduct) {
				updatePackConfig('box', boxProduct);
			}
		};

		if (builderConfig?.box?.handle && builderConfig.box.handle !== '') {
			void fetchBox();
		}
	}, [builderConfig]);

	if (!packConfig?.box) {
		return null;
	}

	return (
		<div className="flex flex-col justify-center gap-2">
			<Typography className="text-center" component="h2" variant="body">
				Special Box
			</Typography>
			<Typography className="text-center" component="h2" variant="heading-sm">
				{packConfig.box.titles?.[0]?.trim()}
			</Typography>
			{packConfig?.box?.images?.[0]?.src && (
				<Image
					alt="product image"
					height={184}
					src={packConfig.box.images[0].src}
					objectFit="contain"
					width={367}
				/>
			)}
		</div>
	);
};

Box.propTypes = {
	builderConfig: PropTypes.object,
	packConfig: PropTypes.object,
	updatePackConfig: PropTypes.func,
};

export default Box;
